import React from "react";
import { useI18n } from "Hooks";

import { Dropdown, IconDisclosure, DropdownMenu } from "@toddle-edu/ds-web";
import { getDefaultAccessOptions } from "StaffPermissions/modules/utils";
import classes from "./PermissionStatusBulkApply.scss";

const styles = {
  itemTitleContainerStyle: { maxWidth: "370px", whiteSpace: "normal" },
};

const BulkApplyAccessAction = props => {
  const { column } = props;
  const {
    metadata: { curriculumAcronym = "" } = {},
    applyBulkUpdateAccess,
  } = column;
  const { t } = useI18n();

  const handleAccessSelect = ({ key }) => {
    applyBulkUpdateAccess(key);
  };

  const permissionsStatusOptions = getDefaultAccessOptions({
    t,
    curriculumAcronym,
  });

  const label = (
    <div className={classes.headerText}>
      {t("common:bulk_apply_access_all_module")}
    </div>
  );
  const accessBulkApplyItemGroup = [
    {
      isItemGroup: true,
      key: "BULK_APPLY",
      label: label,
      options: permissionsStatusOptions,
    },
  ];

  return (
    <Dropdown
      overlay={
        <DropdownMenu
          hasMultilineOptions
          options={accessBulkApplyItemGroup}
          onClick={handleAccessSelect}
          itemTitleContainerStyle={styles.itemTitleContainerStyle}
        />
      }
      placement={"bottomRight"}
    >
      <IconDisclosure variant="dark" />
    </Dropdown>
  );
};

export default BulkApplyAccessAction;
